import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import HttpClient from '../../utils/HttpClient'
import toast from 'react-hot-toast'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon'
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal'
import { ImCross } from 'react-icons/im'
import moment from 'moment'

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "35px",
    fontWeight: "bold"

}

const SponsorAd = () => {
    const initData = {
        adImage: "",
        expiryDate: "",
        adLinkUrl: "",
    }
    const [sponsorAd, setOfferCreate] = useState(initData)
    const [AllData, setAllData] = useState([]);
    const [isLoading, setisLoading] = useState(false)
    const [isEdit, setisEdit] = useState(false);
    const [sponsorAdID, setSponsorAdID] = useState("");


    // select the Image
    const handleChange = async (e) => {
        setisLoading(true)
        const { name, files } = e.target;
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                setOfferCreate(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
                setisLoading(false)
                setisEdit(true)
            }
        }
    };

    //submit data
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!sponsorAd?.adImage) {
            return toast.error("Input Blank")
        }
        setisLoading(true)
        const data = sponsorAd


        const res = await HttpClient.requestData("offer-category", "POST", data)
        if (res && res?.status) {
            toast.success("Successfully created!")
            setisLoading(false)
            viewSponsorAd()
            setOfferCreate(initData)
        }
        else {
            toast.error("Can't Created");
            setisLoading(false)
            viewSponsorAd()
        }
    }

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "10%"
        },
        {
            name: 'Category Name',
            selector: row => row.categoryName,
            width: "40%"
        },
        {
            name: 'Category Image',
            selector: row => row.adImage,
            width: "30%"
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: "20%"
        }



    ];
    //viewOffers 
    const viewSponsorAd = async () => {
        setisLoading(true);
        const res = await HttpClient.requestData("sponserAd", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setisLoading(false);
            setOfferCreate(prev => ({
                ...prev,
                adImage: res?.data[0]?.adImage,
                expiryDate: res?.data[0]?.expiryDate,
                adLinkUrl: res?.data[0]?.adLinkUrl
            }))
            setSponsorAdID(res?.data[0]?._id)
        }
        else {
            setisLoading(false);
        }
        setAllData(apiData);
    }
    //delete offer
    const handleDelete = async (id) => {
        async function del() {
            setisLoading(true);
            const res = await HttpClient.requestData(`offer-category/${id}`, 'DELETE', {})
            if (res && res?.status) {
                toast.success('Category Deleted Successfully');
                setisLoading(false);
                viewSponsorAd()
            }
            else {
                toast.error('Cant Delete!')
                setisLoading(false);
                viewSponsorAd()
            }
        }
        DeleteConfirmModal(del)
    }

    //Edit
    const handleEdit = async (item) => {
        setisEdit(true)
        setSponsorAdID(item?._id)
        setOfferCreate(prev => ({ ...prev, categoryName: item?.categoryName, adImage: item?.adImage }))


    }
    //cancel edit
    const cancelEdit = (e) => {
        setisEdit(false)
        viewSponsorAd()
    }
    //Edit Submit
    const handleEditSubmit = async (e) => {
        e.preventDefault()
        if (!sponsorAd?.adImage) {
            return toast.error("Input Blank")
        }
        setisLoading(true)
        const editFormData = {
            adImage: sponsorAd?.adImage,
            expiryDate: sponsorAd?.expiryDate,
            adLinkUrl: sponsorAd?.adLinkUrl
        }
        // return
        
        const res = await HttpClient.requestData(`sponserAd/${sponsorAdID}`, 'PUT', editFormData)

        if (res && res?.status) {
            toast.success("Updated Successfully");
            setisEdit(false)
            setisLoading(false)
            viewSponsorAd()
            setOfferCreate(initData)
        }
        else {
            setisLoading(false)
            toast.error(res?.message || "Something Wrong");
            setisLoading(false);
            viewSponsorAd()

        }
    }
    useEffect(() => {
        viewSponsorAd();
    }, [])


    return (
        <div>

            <CustomLoader
                loading={isLoading}
            />


            <div className="d-flex justify-content-end">

                <div className="form-header">
                    <section className="piechartsBox_area">
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            Sponsor Ad
                        </div>
                        <form >
                            <div className="row">
                                <div className="col-md-12 mt-3 ">
                                    <label style={{ marginRight: "22px", display: "block" }}>Advertise Image: <span style={{ color: "red" }}>(300 x 250)</span></label>
                                    {sponsorAd?.adImage && <img src={sponsorAd?.adImage} alt="" id='preview' className='mb-2'
                                        style={{ maxWidth: "300px" }}
                                    // onClick={() => handleView(formFourthData?.profilePhoto)}
                                    />}
                                    <input
                                        type="file"
                                        className="mx-1"
                                        placeholder="Advertise Photo"
                                        name="adImage"
                                        // value={formFourthData.profilePhoto}
                                        onChange={(e) => handleChange(e)}
                                        required
                                        style={{ display: "block" }}
                                    />

                                </div>

                                <div className="col-md-6 mt-3 ">
                                    <label style={{ marginRight: "65px" }}>Expiry Date:</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        placeholder="Expiry Date"
                                        name="expiryDate"
                                        value={moment(sponsorAd.expiryDate).format('YYYY-MM-DD')}
                                        onChange={(e) => {
                                            setOfferCreate(prev => ({ ...prev, expiryDate: e.target.value }))
                                            setisEdit(true)
                                        }}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mt-3 ">
                                    <label style={{ marginRight: "65px" }}>Link:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Link Url"
                                        name="adLinkUrl"
                                        value={sponsorAd.adLinkUrl}
                                        onChange={(e) => {
                                            setOfferCreate(prev => ({ ...prev, adLinkUrl: e.target.value }))
                                            setisEdit(true)
                                        }}
                                        required
                                    />
                                </div>

                            </div>

                            {!isEdit ?
                                <></>
                                // <Button variant="contained" color="primary" className='mx-2 mt-2' onClick={(e) => handleSubmit(e)}>
                                //     Save
                                // </Button>
                                :
                                <div>
                                    <Button variant="contained" color="primary" className='mx-2 mt-2' onClick={(e) => handleEditSubmit(e)}>
                                        Update
                                    </Button>    <ImCross
                                        onClick={(e) => cancelEdit(e)}
                                        style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " />
                                </div>
                            }
                            {/* <ImageModal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)}
            SelectedImage={SelectedImage} /> */}
                        </form>
                        <div className='mt-2'>

                            {/* <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded mt-1"
                                customStyles={customStyles}
                            /> */}
                        </div>
                    </section>
                </div>

            </div >




        </div >
    )
}

export default SponsorAd